
import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../base/Logo';
import { CITY, EMAIL, PHONE, PHONE_HREF } from '../../libs/constants';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d69gaelbiueuoqm1ru80', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setIsSuccess(true);
        setEmail('');
      }
    } catch (err) {
      console.error('Subscription failed:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-50 via-teal-50/30 to-emerald-50/30">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Logo size="lg" linkTo="/" />
            <p className="text-gray-600 leading-relaxed">
              Smart shopping starts here. Compare prices, track deals, and save money on millions of products.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 bg-gray-100 hover:bg-teal-500 hover:text-white rounded-full flex items-center justify-center transition-colors cursor-pointer text-gray-600">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 hover:bg-teal-500 hover:text-white rounded-full flex items-center justify-center transition-colors cursor-pointer text-gray-600">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 hover:bg-teal-500 hover:text-white rounded-full flex items-center justify-center transition-colors cursor-pointer text-gray-600">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 hover:bg-teal-500 hover:text-white rounded-full flex items-center justify-center transition-colors cursor-pointer text-gray-600">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-6">Product</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Compare Prices</Link></li>
              <li><Link to="/categories" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Categories</Link></li>
              <li><Link to="/deals" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Hot Deals</Link></li>
              <li><Link to="/notifications" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Price Alerts</Link></li>
              <li><Link to="/compare" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Product Compare</Link></li>
              <li><Link to="/extension" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Browser Extension</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-6">Support</h4>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Contact Us</Link></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Help Center</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">Terms of Service</a></li>
            </ul>
            <div className="mt-6 space-y-3 text-sm text-gray-600">
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-teal-600 transition-colors">
                <i className="ri-mail-line text-teal-500"></i>
                <span>{EMAIL}</span>
              </a>
              <a href={PHONE_HREF} className="flex items-center gap-2 hover:text-teal-600 transition-colors">
                <i className="ri-phone-line text-teal-500"></i>
                <span>{PHONE}</span>
              </a>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-teal-500"></i>
                <span>{CITY}</span>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-6">Never Miss a Deal</h4>
            <p className="text-gray-600 mb-4 text-sm">
              Get the best deals delivered to your inbox weekly.
            </p>
            {isSuccess ? (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center gap-2 text-green-700">
                  <i className="ri-check-circle-fill"></i>
                  <span className="text-sm font-medium">Subscribed!</span>
                </div>
              </div>
            ) : (
              <form
                id="footer-newsletter-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-3"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full px-4 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-600 hover:to-emerald-600 text-white rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap disabled:opacity-70"
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <div className="text-gray-500 text-sm text-center lg:text-left">
              © 2025 Ohprice. All rights reserved.
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center items-center gap-6">
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <i className="ri-shield-check-line text-green-500"></i>
                <span>100% Free</span>
              </div>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <i className="ri-lock-line text-teal-500"></i>
                <span>Secure</span>
              </div>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <i className="ri-customer-service-line text-teal-500"></i>
                <span>24/7 Support</span>
              </div>
            </div>

            {/* Links */}
            <div className="flex items-center gap-4 text-sm">
              <a href="#" className="text-gray-500 hover:text-teal-600 transition-colors cursor-pointer">Privacy</a>
              <a href="#" className="text-gray-500 hover:text-teal-600 transition-colors cursor-pointer">Terms</a>
              <a href="https://www.softcreative.co.uk" className="text-gray-500 hover:text-teal-600 transition-colors cursor-pointer">developed by Soft Creative Ltd</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
